import { hasCapability, type User } from "../base";

export const personToContractor = {
  read: (user: User, contractorId?: string) => {
    if (hasCapability(user, "personToContractor.read.all")) {
      return true;
    }
    return user.person.organizationId === contractorId && hasCapability(user, "personToContractor.read.org");
  },
  update: (user: User) => hasCapability(user, "personToContractor.update"),
};
